<template>
    <div class="mini_profile_wrapper">
        <div @click="toggleProfile" class="mini_profile">
            <Avatar :user="auth.user" class="mini_profile__avatar" />
            <div class="arrow"></div>
        </div>

        <div v-if="isMiniProfileOpen" class="mini_profile__container">

            <div @click=openProfile class="mini_profile__header">
                <Avatar :user="auth.user" class="mini_profile__avatar" />

                <div class="mini_profile__text_box">
                    <p class="mini_profile__name">{{ auth.user?.name }}</p>
                    <p class="mini_profile__phone">{{ maskPhone(auth.user?.phonenumber) }}</p>
                </div>
            </div>

            <button @click=logout v-if="auth.user" class="logout">
                <img data-dark="/return.svg" data-light="/return_light.svg" alt="Go out" loading="lazy"
                    :src="currentImage">
                {{ $t('exit') }}</button>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useThemeStore } from "@/stores/themeStore";
import Avatar from "../Avatar.vue";
import { useClickOutside } from "@/composables/useClickOutside.js";

export default {
    name: "MiniProfile",
    data() {
        return {
            auth: useAuthStore(),
            themeStore: useThemeStore(),
            isMiniProfileOpen: false,
            currentImage: ref(""),
            removeClickOutside: null,
        };
    },
    components: { Avatar },
    methods: {
        updateImage() {
            this.currentImage = this.themeStore.isDark
                ? new URL("/return.svg", import.meta.url).href
                : new URL("/return-light.svg", import.meta.url).href;
        },
        maskPhone(phone) {
            if (!phone) return "";
            return phone.replace(/(\+7)(.*)(\d{4})$/, (m, start, middle, end) => {
                return start + "......" + end;
            });
        },
        logout() {
            this.auth.logout();
            this.isMiniProfileOpen = false;
        },
        openProfile() {
            this.$router.push({ name: "Profile" });
            this.isMiniProfileOpen = false;
        },
        toggleProfile() {
            this.isMiniProfileOpen = !this.isMiniProfileOpen;
        },
    },
    mounted() {
        this.updateImage();
        this.removeClickOutside = useClickOutside(
            this.$el,
            () => this.isMiniProfileOpen = false
        );
    },
    beforeUnmount() {
        this.removeClickOutside?.();
    },
    watch: {
        "themeStore.isDark": function () {
            this.updateImage();
        },
    },
}
</script>

<style>
.mini_profile_wrapper {
    height: 100%;
}

.mini_profile {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    cursor: pointer;
    padding: 0 10px;
}

.mini_profile:hover {
    background-color: var(--hover);
}

.mini_profile__avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    object-fit: cover;
}

.mini_profile__container {
    position: absolute;
    top: 65px;
    padding: 10px 12px;
    border: 1px solid var(--border-color);
    border-radius: 15px;
    right: 2.5%;
    background-color: var(--mini-profile-bg);
}

.mini_profile__header {
    display: flex;
    align-items: center;
    text-align: left;
    margin-bottom: 8px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 10px;
    padding: 2px 4px;
}

.mini_profile__header:hover {
    background-color: var(--hover);
}

.mini_profile__name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
}

.mini_profile__text_box {
    display: flex;
    color: var(--text-color);
    flex-direction: column;
    margin-left: 16px;
}

.mini_profile__phone {
    color: rgba(174, 174, 178, 1);
    font-size: 13px;
}

.arrow {
    transform: translateY(-50%) rotate(45deg);
    width: 6px;
    height: 6px;
    margin-top: 5px;
    margin-left: 10px;
    border-right: 2px solid rgba(189, 189, 189, 1);
    border-bottom: 2px solid rgba(189, 189, 189, 1);
    pointer-events: none;
}

.logout {
    padding: 8px 32px;
    border-radius: 10px;
    background: var(--text-hover-color);
    color: var(--text-color);
    cursor: pointer;
    transition: 0.2s all;
    width: 180px;
    position: relative;
    text-align: left;
    font-weight: 600;
}

.logout:hover {
    background-color: rgba(201, 22, 22, 0.6);
}

.logout img {
    position: absolute;
    top: 10px;
    width: 15px;
    height: 15px;
    left: 12px;
}

@media (max-width: 500px) {
    .mini_profile {
        margin: 0 8px;
    }
}
</style>
